const mContentEditorBlockInputLink = {
  mContentEditorBlockInputLink: {
    inputs: {
      link: {
        placeholder: 'Pega aquí la url del enlace.'
      }
    }
  }
}

export default mContentEditorBlockInputLink
